module.exports = global["_"] = require("-!./underscore.js");


//////////////////
// WEBPACK FOOTER
// ../~/underscore/underscore.js
// module id = 64
// module chunks = 0